import { useContext, useState,useEffect,forwardRef } from "react";
import { FaUser } from "react-icons/fa";
import { AuthContext } from '../../context/AuthContext';
import { postComment } from "../../_services/carsService";
import { ToastContext } from "../../context/ToastContext";
import { fetchCarComments } from "../../_services/carsService";
import { postReply } from "../../_services/carsService";

const CommentSection = forwardRef(({car,setCommentsCount},ref) => {
  const [commentInput, setCommentInput] = useState('');
  const [comments, setComments] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyInput, setReplyInput] = useState('');
  const { isLoggedIn, login, userInfo } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);
  const [error, setError] = useState(null);

  const handleAddComment = async () => {

    if (!isLoggedIn) {
      const loginEvent = new Event("openLoginModal");
      window.dispatchEvent(loginEvent); // Dispatch global event
      return;
    }
    else if (commentInput.trim()) {
      const savedComment = await postComment(commentInput.trim(),car.id);
      
      const newComment = {
        text: commentInput.trim(),
        timestamp: new Date(),
        username: userInfo.name,
        votes: 0,
        avatar: userInfo.image_url,
        replies: [],
      };
    
      setComments([newComment, ...comments]);
      setCommentInput('');
      setCommentsCount((prevCount) => prevCount + 1); 
    }
  };

  const handleAddReply = async (index, parentCommentId) => {
    if (replyInput.trim()) {
      const savedReply = await postReply(replyInput.trim(), parentCommentId, car.id);
      const updatedComments = [...comments];
      
      if (!updatedComments[index].replies) {
        updatedComments[index].replies = [];  // <-- Initialize if missing
      }
  
      updatedComments[index].replies.push({
        text: replyInput.trim(),
        timestamp: new Date(),
        username: userInfo.name,
        avatar: userInfo.image_url,
      });
      
      setComments(updatedComments);
      setReplyInput('');
      setReplyingTo(null);
    }
  };
  
  const handleLoadMore = () => setVisibleCount((prev) => prev + 3);

  const formatTime = (date) => {
    if (date) {
      const d = new Date(date);
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(d);
      const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }).format(d);
      
      return `${formattedDate} at ${formattedTime}`;
  }
  };
  

  useEffect(() => {
    const getCarComments = async () => {
      try {
        const data = await fetchCarComments(car.id);
        setComments(data);
        //setting the initial count
        setCommentsCount(data.length);
      } catch (err) {
        console.error("Error fetching car comments:", err);
        setError(err);
        showToast("Failed to fetch comments. Please try again later.", "danger");
      } 
    };
  
    getCarComments();
  }, []);
  return (
    <div ref={ref} className="mt-4 w-full max-w-2xl mx-auto px-4">
      <h4 className="text-xl font-semibold mb-4 text-center">Comments</h4>

      {/* Input Area */}
      <div className="mb-6">
        <textarea
          className="block w-full p-2 border rounded resize-none mb-2"
          rows={2}
          placeholder="Write a comment..."
          value={commentInput}
          onChange={(e) => setCommentInput(e.target.value)}
          style={{ width: '100%' }}
          disabled={car?.seller_email === userInfo?.email}
        />
        <div className="mt-2">
          <button
            onClick={handleAddComment}
            className={`bg-blue-600 text-black px-4 py-2 rounded hover:bg-blue-700 transition ${
              !commentInput.trim() ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            disabled={!commentInput.trim()}
          >
            Submit
          </button>
        </div>
      </div>

      {/* Comment List */}
      <div className="space-y-4 p-4 border-t">
        {comments.slice(0, visibleCount).map((comment, index) => (
          <div key={index} className="mt-4">
            <div className="d-flex flex-row gap-3 text-sm text-gray-800">
            {comment.image_url ? (
                <img
                  src={comment.image_url}
                  alt="avatar"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '9999px',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <FaUser size={24} className="me-2" />
              )}
              <span className="font-semibold text-black">{comment.user_email}</span>
              <span className="text-xs text-gray-500">{formatTime(comment.created_at)}</span>
            </div>

            <div className="flex-1">
              <p className="ml-2 mb-2" style={{ marginLeft: '60px' }}>
                {comment.text}
              </p>

              <div className="d-flex flex-row mt-2 gap-2" style={{ marginLeft: '60px' }}>
                <button
                  onClick={() => console.log('Like clicked')}
                  className="bg-transparent border-none text-blue-600 hover:underline cursor-pointer p-0 m-0"
                  style={{ all: 'unset', cursor: 'pointer', color: '#2563eb' }}
                >
                  Vote
                </button>
                <span>|</span>
                <button
                  onClick={() => setReplyingTo(replyingTo === index ? null : index)}
                  className="bg-transparent border-none text-blue-600 hover:underline cursor-pointer p-0 m-0"
                  style={{ all: 'unset', cursor: 'pointer', color: '#2563eb' }}
                >
                  Reply
                </button>
              </div>
              {replyingTo === index && (
                  <div className="mt-2" style={{ marginLeft: '70px', width: '95%', position: 'relative' }}>
                  
                    <textarea
                      className="block w-full p-2 border rounded resize-none mb-2"
                      rows={1}
                      placeholder="Write a reply..."
                      value={replyInput}
                      onChange={(e) => setReplyInput(e.target.value)}
                      style={{
                        width: '100%',
                        paddingRight: '50px', // Add padding for button space
                        height: replyInput ? '80px' : '40px', // Adjust height based on input
                        borderRadius: '90px',
                      }}
                    />
                    {replyInput && (
                      <button
                        onClick={()=>handleAddReply(index,comment.id)}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          bottom: '20px', // Adjust bottom position to keep it inside
                          backgroundColor: '#007BFF',
                          color: '#fff',
                          border: 'none',
                          padding: '3px 8px', // Reduce padding to make the button smaller
                          fontSize: '12px', // Adjust font size to fit better
                          borderRadius: '20px',
                          cursor: 'pointer',
                          height: '28px', // Set a fixed height for the button
                          width: 'auto', // Auto width to adjust based on padding
                          lineHeight: '16px', // Make sure text is vertically centered
                        }}
                      >
                        Reply
                      </button>
                    )}
                  </div>
                )}


              {/* Replies */}
              {comment.replies && comment.replies.length > 0 && (
                <div className="mt-2" style={{ marginLeft: '60px' }}>
                  {comment.replies.map((reply, rIndex) => (
                    <div key={rIndex} className="mb-2">
                      <div className="d-flex flex-row gap-2 text-sm text-gray-800">
                      {reply.image_url ? (
                          <img
                            src={reply.image_url}
                            alt="avatar"
                            style={{
                              width: '30px',
                              height: '30px',
                              borderRadius: '9999px',
                              objectFit: 'cover',
                            }}
                          />
                        ) : (
                          <FaUser size={24} className="me-2" />
                        )}
                        <span className="font-semibold text-black">{reply.user_email}</span>
                        <span className="text-xs text-gray-500">{formatTime(reply.created_at)}</span>
                      </div>
                      <p className="ml-2" style={{ marginLeft: '45px' }}>{reply.text}</p>
                      <div className="flex gap-2 text-sm text-blue-600 ml-12 mt-1">
                          <button
                            onClick={() => console.log('Reply Vote clicked')}
                            style={{ all: 'unset', cursor: 'pointer', color: '#2563eb' }}
                          >
                            Vote
                          </button>
                          <span> | </span>
                          <button
                            onClick={() => console.log('Reply clicked (nested reply)')}
                            style={{ all: 'unset', cursor: 'pointer', color: '#2563eb' }}
                          >
                            Reply
                          </button>
                        </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Load More */}
      {visibleCount < comments.length && (
        <div className="text-center mt-4">
          <button
            onClick={handleLoadMore}
            className="bg-blue-600 text-black px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Load More Comments
          </button>
        </div>
      )}
    </div>
  );
});

export default CommentSection;
